"use client";

import type { ReactNode } from "react";
import {
	ArtistIcon,
	EmptyState,
} from "@/components/design-system/ArtistDesignSystem";

function AppleLogoGlyph(): ReactNode {
	return (
		<svg
			width={38}
			height={38}
			viewBox="0 0 24 24"
			aria-hidden="true"
			fill="currentColor"
		>
			<path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.804-.94 2.142-1.64 3.248-1.68.03.13.04.28.04.43zm4.565 15.71c-.03.07-.463 1.58-1.518 3.12-.945 1.34-1.94 2.71-3.43 2.71-1.517 0-1.9-.88-3.63-.88-1.698 0-2.302.91-3.67.91-1.377 0-2.332-1.26-3.428-2.8-1.287-1.82-2.323-4.63-2.323-7.28 0-4.28 2.797-6.55 5.552-6.55 1.448 0 2.675.95 3.6.95.865 0 2.222-1.01 3.902-1.01.613 0 2.886.06 4.374 2.19-.13.09-2.383 1.37-2.383 4.19 0 3.26 2.854 4.42 2.955 4.45z" />
		</svg>
	);
}

/**
 * AppleMusicConnectState — permission-denied state matching iOS `DSEmptyState`
 * shown when Apple Music scope is selected without `MusicAuthorization.authorized`.
 *
 * On web there is no MusicKit authorization path, so this state truthfully
 * explains that Apple Music catalog search requires the native app. The
 * `onConnect` callback lets the host surface a fallback (e.g. open the
 * Apple Music web player). Satisfies the contract's `permissionDenied`
 * required state for the `search.catalog` page group.
 */
export function AppleMusicConnectState({
	onConnect,
}: Readonly<{ onConnect?: () => void }>) {
	const actionProps = onConnect === undefined ? {} : { onAction: onConnect };
	return (
		<div className="search-applemusic-connect">
			<EmptyState
				symbol={<AppleLogoGlyph />}
				title="连接 Apple Music"
				message="Apple Music 目录搜索需要在原生 App 中授权连接。在 Artist iOS App 中连接后，即可在此搜索整个目录。"
				actionLabel="了解详情"
				actionSymbol={<ArtistIcon name="chevron" size={16} />}
				{...actionProps}
			/>
		</div>
	);
}
